/**
 * This module contains the UI
 * to build the motor instruction category
 */

// TODO:
// - reduce unneeded notifications
// - unbind events of removed UI elements
// - unify styles
// - actuator type listeners
(function() {
  const $ = require('jQuery');
  const instruction_widgets = require('../instruction_widgets');
  const ml = require('../../machinelogic');
  const icons = require('../../icons');
  const widgets = require('../widgets');
  const tooltips = require('../machinelogic_tooltips');
  const helpers = require('../../helpers');
  const utils = require('./utils');

  const { autocompleteComponent } = require('../vse_ui/vse_components/base_components');

  function create(pParameters) {
    const lLibrary = pParameters.library;
    const lApp = pParameters.application;
    const lSequence = pParameters.sequence;
    const lInstruction = pParameters.instruction;
    const _lDiv = $('<div class="ml_instruction h_layout"/>');
    const _lCard = widgets.card(icons[lInstruction.getCategory()], function () {
      lSequence.removeInstruction(lSequence.getInstructionIndex(lInstruction));
    }).attr('id', widgets.idGenerator.nextInstructionId());
    let _lParameterNameToWidgetMapping = {};
    let _lSwitchedToCombinedMovement = null;
    let _lQueriedActions = null;
    let _lFilteredActionsSet;
    let _lCachedAxisUuid;
    const _lGetFirstValidAxisUuid = function () {
      if (_lCachedAxisUuid) {
        const lCachedAxis = lLibrary.getConfigManager().getAxisByUuid(_lCachedAxisUuid);
        if (!lCachedAxis.isNonMotorized()) {
          return lCachedAxis.getUUID();
        }
      }

      const lAxis = lLibrary.getConfigManager().listAxes().find(function(pAxis) {
        return !pAxis.isNonMotorized();
      });
      return lAxis ? lAxis.getUUID() : ml.reservedUuids.NONE;
    };
    const _lApplicationParameterObject = lApp.getParametersObject();
    const _lAddAxisButton = widgets.inlineButtonWithText(icons.addPlus, 'Actuators', function () {
      const lConfigManager = lLibrary.getConfigManager(); const lInstructionName = lInstruction.getName();
      // Remove axis: switch back to a single instruction
      if (_lSwitchedToCombinedMovement) {
        if (lConfigManager.numberOfAxes() <= 0) { widgets.messageBox('Please go to configuration and add an actuator', 'warning'); return; }
        // move relative because all axis are able to perform it
        // check if the first axis is compatible with moveAbsolute
        const lAxisUuid = _lGetFirstValidAxisUuid();
        const lAxisType = lAxisUuid && lConfigManager.getAxisByUuid(lAxisUuid).getType();
        const lMoveAbsoluteAllowedAxisType = lInstruction.mInstructionSet.motor.moveAbsolute.parameters[0].allowedAxisType;

        if (lConfigManager.numberOfAxes() > 0 && lConfigManager.numberOfRealAxes() == 0) {
          // Only pneumatics configured, override the default instruction
          const lAxis = lLibrary.getConfigManager().listAxes()[0];
          const lAxisType = lAxis && lAxis.getType();
          // _lCachedAxisUuid needs to be set for the following to work.
          _lCachedAxisUuid = lAxis.getUUID();
          if(lAxisType === "pneumatic_bag_gripper"){
            lInstruction.setName('close');
          } else {
            lInstruction.setName('push');
          }
        }
        else if(lInstructionName.match(/relative/i)) {              lInstruction.setName('moveRelative'); }
        else if(lMoveAbsoluteAllowedAxisType.includes(lAxisType)) { lInstruction.setName('moveAbsolute'); }
        else {                                                      lInstruction.setName('moveRelative'); }

        _lAddAxisButton.updateIcon(icons.addPlus);
        _lSwitchedToCombinedMovement = null;
        return;
      }

      const lAxis = lLibrary.getConfigManager().getAxisByUuid(_lCachedAxisUuid);
      const lConfig = lAxis ? lAxis.getConfig() : undefined;

      // Pre condition to add combined motion
      if (lConfig && lConfig.numberOfRealAxes() < 2) {
        widgets.messageBox('Please go to configuration and add one more actuator', 'warning');
        return;
      }
      // if lInstruction is not a move combined it means we are switching to a combined motion
      // also, it means we are adding the second axis
      if (!lInstruction.isCombined()) {
        // if the current instruction is moveAbsolute(moveToPosition) we switch to moveAbsoluteCombined
        // otherwise set moveRelativeCombined
        _lSwitchedToCombinedMovement = true;
        _lAddAxisButton.updateIcon(icons.removeCircle);
        if (lInstructionName.match(/absolute/i)) {
          lInstruction.setName('moveAbsoluteCombined');
        } else {
          lInstruction.setName('moveRelativeCombined');
        }
      }

    }).css({ 'margin-left': 'calc(1.25rem + 5px)' });
    const _getUnitForMotorInstruction = function (pInstruction, pParameter, pConfigManager) {
      // Units for setAcceleration instructions
      if (pInstruction.getName() === 'setAcceleration') {
        const showBothUnits = pConfigManager.listAxes().some(axis => axis.getUnits() == 'deg' || axis.getType() == 'pneumatic');
        if (showBothUnits) { return `(mm/deg)/s<sup>2</sup>`; }
        else { return `mm/s<sup>2</sup>`; }
      }
      // Units for setSpeed instructions
      else if (pInstruction.getName() === 'setSpeed') {
        const showBothUnits = pConfigManager.listAxes().some(axis => axis.getUnits() == 'deg' || axis.getType() == 'pneumatic');
        if (showBothUnits) { return `(mm/deg)/s`; }
        else { return `mm/s`; }
      }

      // For the rest of the motor instruction we need to get the axis based on the parameter.axis, not based on the order
      const lSplitParameter = pParameter.split('.');
      let lAxis = undefined;
      let lAxisUnit = '';
      let lAxisUuid;

      // deal with single ('axis') or combined move ('axes.i.axis')
      if (lSplitParameter.length < 2 || lSplitParameter[0] !== 'axes') {
        lAxisUuid = pInstruction.getParameter('axis');
      }
      else {
        lAxisUuid = pInstruction.getParameter([lSplitParameter[0], lSplitParameter[1], 'axis'].join('.'));
      }

      lAxis = lLibrary.getConfigManager().getAxisByUuid(lAxisUuid);
      if (lAxis) { lAxisUnit = lAxis.getUnits(); }
      else { return ''; }

      if (lSplitParameter[0] === 'speed') {
        return `${lAxisUnit}/s`;
      }
      else if (lSplitParameter[0] === 'acceleration') {
        return `${lAxisUnit}/s<sup>2</sup>`;
      }

      return lAxisUnit;
    };
      // Note (alevy): this function does not return a widget
      // it adds widgets to _lCard
    const _parameterWidget = function (pParameterInfo, pParameter) {
      let _lWidget;

      switch (pParameterInfo.format) {
        case 'oneOf': {
          if (pParameterInfo.unit == 'axis') {
            let _lParameter = lInstruction.getParameter(pParameter);

            if(_lParameter && !lLibrary.getConfigManager().getAxisByUuid(_lParameter)) {
              // NOTE: we need this check for the CAD, as the CAD does not reload, an unknow UUID (ex: after axis erase) will not be converted to UNKNOWN
              _lParameter = ml.reservedUuids.UNKNOWN;
            }
            if(lInstruction.getName().match(/Combined/i) && _lParameter == undefined) { _lParameter = ml.reservedUuids.NONE; }

            // Combined moved instruction can have (Not Selected) option
            const _lAllowNotSelected = lInstruction.mName.match('Combined') ? true : (pParameterInfo.allowEmpty || false);

            _lWidget = instruction_widgets.axisParamWidget(
              lLibrary.getConfigManager(), lInstruction, pParameter, pParameterInfo.name,
              pParameterInfo.description, _lAllowNotSelected,
              pParameterInfo.allowedAxisType, (undefined == _lParameter ? ml.reservedUuids.ALL : _lParameter),
              function (pValue) {
                (ml.reservedUuids.ALL != pValue && lInstruction.listAxisParametersNames().includes(pParameter)) && lInstruction.setParameter(pParameter, pValue);
              }
            );
            // Don't show the widget. Widget is shown for device parameter.
          } else if (pParameterInfo.unit == 'pneumaticPin') {
            // Don't show the widget
          } else {
            // read digital input to add or not
            // waitOnMotionCompletion
            // See Ticket #86
            let pParameterName = pParameterInfo.name;
            if ('device' === pParameterInfo.name) {
              pParameterName = 'control device';
            }
            _lWidget = widgets.listWidget(pParameterName, pParameterInfo.values, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            });
            // wait on motion completion parameter
            // from push|pull instruction

            if (undefined !== _lCachedAxisUuid && pParameter === 'waitOnMotionCompletion') {
              const lAxis = lLibrary.getConfigManager().getAxisByUuid(_lCachedAxisUuid);
              _lWidget = undefined;
              let lShow = false;
              const lWaitForCompletion = lInstruction.getParameter(pParameter) === 'true';
              if(lWaitForCompletion) {
                // we will always show the checkox, even if no pins are configured or the actuator is missing
                lShow = true;
              }
              else {
                if(lAxis && lAxis.isNonMotorized()) {
                  if(/pull/.test(lInstruction.getName()) && lAxis.getPin('pullInPin') != null) { lShow = true; }
                  else if(/push/.test(lInstruction.getName()) && lAxis.getPin('pushInPin') != null) { lShow = true; }
                  else if(/open/.test(lInstruction.getName()) && lAxis.getPin('pullInPin') != null) { lShow = true; }
                  else if(/close/.test(lInstruction.getName()) && lAxis.getPin('pushInPin') != null) { lShow = true; }
                }
              }
              if(lShow) {
                // build the waitOnMotionCompletion
                _lWidget = widgets.checkBoxParameter('waitForThisMotionToComplete', lWaitForCompletion, function(pValue) {
                  lInstruction.setParameter(pParameter, String(pValue));
                });
              }
            }
          }
          break;
        }
        case 'float': {
          _lWidget = autocompleteComponent(
            helpers.transformToTitleCase(pParameterInfo.name),
            pParameterInfo.description,
            lInstruction.getParameter(pParameter),
            lApp.listAllApplicationParameterNames(),
            (pValue) => { lInstruction.setParameter(pParameter, pValue); },
            [
              helpers.getExpressionValidationFunction(lApp.getParametersObject()),
              helpers.required,
              helpers.getMinMaxValidationFunction({ 'min': pParameterInfo.minimum, 'max': pParameterInfo.maximum })
            ],
            { getUnit: () => { return _getUnitForMotorInstruction(lInstruction, pParameter, lLibrary.getConfigManager()); }}
          );

          if(lLibrary.getConfigManager().numberOfAxes() == 0) {
            _lWidget.disableInput();
          }
          break;
        }
        case 'blank': {
          _lCard.parameters.append($('<div></div>'));
          // This is to use blank to the move combined
          const hasBlankOnModel = lInstruction._getInstructionModel().parameters.find(function (paramObject) { return 'blank' === paramObject.format; });
          hasBlankOnModel && lInstruction.setParameter(pParameter, "blank"); // For UI purposes
          break;
        }
        case 'array': {
          buildCombinedInstruction(_lCard, pParameterInfo, pParameter);
          break;
        }
        default: {
          _lWidget = widgets.baseWidget(pParameterInfo.name).append($('<div>' + pParameterInfo.format + ' not supported</div>'));
          break;
        }
      }

      if (_lWidget) {
        _lParameterNameToWidgetMapping[pParameter] = _lWidget;
        if (_lWidget.widget) { _lWidget = _lWidget.widget; }
        _lWidget.addClass('v_layout spaced');
        _lCard.parameters.append(_lWidget);
      }
    };
    let _lActions;
    const _onAction = function (pAction) {
      lInstruction.setName(pAction);
    };
    const _lInstructionListener = {
      onParameterChanged: function (pParamName, pValue) {
        // Note (AJ): This listener is solely required by the teach position feature available in cad, which provides an alternate
        // way to set the value of the position. When this happens we have to update the associated text input as well and hence this
        // listener.
        // We also have to do this exclusively because for many other parameter widgets .updateValue does NOT exists and throw and error.
        // This is not a desireable solution and we shall clean it up with the upcoming right pane re - architecture push.
        if (pParamName.includes('position')) {
          _lParameterNameToWidgetMapping[pParamName].updateValue(pValue);
        }
      },
      onAxisChanged: function (pAxisUuid) {
        // Filter actions based on the axis.
        _lFilteredActionsSet = getActions(lLibrary, lInstruction, pAxisUuid);
        const lFilteredActionsKeys = utils.getActionList(_lFilteredActionsSet);
        _lQueriedActions = true;

        // for combined move we don't modify the instruction
        const lCurrentAction = lInstruction.getName();
        if (lCurrentAction.match(/combined/i)) {
          return;
        }

        if (pAxisUuid !== ml.reservedUuids.ALL){
          _lCachedAxisUuid = pAxisUuid;
        }

        // Reset default instruction - Move Relative
        // Set the new axis
        // Rebuild the instruction

        // Reset default instruction if necessary
        const lActionSetList = Object.keys(_lFilteredActionsSet);
        const lDoesActuatorSupportCurrentMotion = lActionSetList.includes(lCurrentAction);
        if (lDoesActuatorSupportCurrentMotion) {
          _lActions.updateOptions(lFilteredActionsKeys);
          _lActions.setValue(lCurrentAction);
          buildInstruction(_lCard, lInstruction, _lActions);
        }
        else {
          lInstruction.setName(lActionSetList[0]);
        }
      },
      onNameChanged: function (pName) {
        // when we switch to move combined
        // we don't update the actions, so that
        // we do it again in the name changed.
        const lInstructionModel = lInstruction._getInstructionModel();
        const filteredByAllAxes = lInstructionModel.hasOwnProperty('uiProps') && lInstructionModel.uiProps.filteredByAllAxes;

        // we should not filter the actions if was filtered in the axis changed or
        // it is an all axes option;
        if (!_lQueriedActions || !filteredByAllAxes) {
          _lFilteredActionsSet = getActions(lLibrary, lInstruction, filteredByAllAxes ? null : _lCachedAxisUuid);
        } else {
          _lQueriedActions = null;
        }
        const lFilteredActionsKeys = utils.getActionList(_lFilteredActionsSet);
        _lActions.updateOptions(lFilteredActionsKeys);
        _lParameterNameToWidgetMapping = {};
        _lActions.setValue(pName);
        // Set the axis again, because a new instruction would apply the default axis
        // Note (alevy): The instruction axis range is from [1-4]
        lInstruction.listAxisParametersNames().includes('axis') && lInstruction.setParameter('axis', _lCachedAxisUuid);
        _lCard.parameters.removeClass('one_param two_param three_param'); // Reset style of array
        buildInstruction(_lCard, lInstruction, _lActions);


      },
      onParameterUnitChanged: function (pName, pAxisUuid) {
        if (_lParameterNameToWidgetMapping.hasOwnProperty(pName)) {
          const axis = lLibrary.getConfigManager().getAxisByUuid(pAxisUuid);
          if (axis) {
            _lParameterNameToWidgetMapping[pName].updateUnit();
          } else {
            _lParameterNameToWidgetMapping[pName].updateUnit('');

          }
        }
      },
      onParameterAxisSelected: function (pName, pOldAxisUuid, pNewAxisUuid) {
        if (_lParameterNameToWidgetMapping.hasOwnProperty(pName)) {
          // If previous axis was unknown, remove this option from the current dropdown (need to verify the value as all dropdowns receive this notication)
          if(pOldAxisUuid === ml.reservedUuids.UNKNOWN) {
            if(_lParameterNameToWidgetMapping[pName].find('select').val() === pNewAxisUuid) {
              _lParameterNameToWidgetMapping[pName].find('option[value="' + ml.reservedUuids.UNKNOWN + '"]').remove();
            }
          }
          // for cases when the configuration changes (axis type)
          // we should not remove the disable attribute if the axis is not compatible with the instruction
          // find if instruction is supporting the actuator as
          if(pOldAxisUuid != ml.reservedUuids.NONE && pOldAxisUuid != ml.reservedUuids.ANY) {
            const lOldAxis = lLibrary.getConfigManager().getAxisByUuid(pOldAxisUuid);
            let lAllowedActuatorsTypes = [];

            // (for simplicity) this assumes that moveAbsolute and moveAbsoluteCombine have the same allowedAxisType
            if(lInstruction.mName.match(/moveRelative/)) {
              lAllowedActuatorsTypes = lInstruction.mInstructionSet.motor.moveRelative.parameters[0].allowedAxisType;
            }
            else if(lInstruction.mName.match(/moveAbsolute/)) {
              lAllowedActuatorsTypes = lInstruction.mInstructionSet.motor.moveAbsolute.parameters[0].allowedAxisType;
            }

            if(lOldAxis && lAllowedActuatorsTypes.includes(lOldAxis.getType())){
              // Make the previous option available in all drowpdowns
              _lParameterNameToWidgetMapping[pName].find('option[value="' + pOldAxisUuid + '"]').removeAttr('disabled');
            }
          }

          // Make the new option not available
          if (pNewAxisUuid) { _lParameterNameToWidgetMapping[pName].find('option[value="' + pNewAxisUuid + '"]').attr('disabled', 'disabled'); }
        }
      }
    };

    /**
     * Get the instruction depending on the axis
     * @param {Object} pLibrary           - Library Object
     * @param {Object} pInstruction       - Instruction Object
     * @param {String} pAxisUuid          - Axis unique ID
     */
    const getActions = function (pLibrary, pInstruction, pAxisUuid) {
      const lInstructionModel = pInstruction._getInstructionModel();
      const filteredByAllAxes = lInstructionModel.hasOwnProperty('uiProps') && lInstructionModel.uiProps.filteredByAllAxes;
      const lInstructionName = pInstruction.getName();
      pAxisUuid = pAxisUuid || pInstruction.getParameter('axis');
      let lActionsList;

      if ((ml.reservedUuids.ALL == pAxisUuid) || (!pAxisUuid && filteredByAllAxes)) {
        return pLibrary._getAllAxesActionSet();
      }

      // Note: axes will look for combined instruction, axis will look for single-actuator instruction
      if(lInstructionName.match(/combined/i)) {
        // We want all possible instructions for all axes, not only from the first one
        const lCombinedActions = pLibrary.getConfigManager().listAxes().reduce(function(pAccumulator, pCurrent) {
          Object.assign(pAccumulator, pLibrary._getAxisCompatibleActionSet('motor', pCurrent, 'axes'));
          return pAccumulator;
        }, {});
        lActionsList = lCombinedActions;
      }
      else {
        const lAxisObj = pLibrary.getConfigManager().getAxisByUuid(pAxisUuid);
        lActionsList = pLibrary._getAxisCompatibleActionSet('motor', lAxisObj, 'axis');
      }

      return lActionsList;
    };

    /**
       * Hash the parameters by parameters.name
       * @param {Array} pParameters - array of object parameters
       */
    const hashByName = function (pParametersInner) {
      return Object.values(pParametersInner).reduce(function (acc, parameter) {
        acc[parameter.name] = Object.assign({}, parameter);
        return acc;
      }, {});
    };
      /**
       * Build the instruction card
       * @param {jQuery} pCard - a jQuery object representing the _lCard
       * @param {Object} pInstruction - Instruction Object
       * @param {jQuery} pActions - a jQuery object representing the _lActions
       * @returns this function does not return anything
       */
    const buildInstruction = function (pCard, pInstruction, pActions) {
      // Detach the children and build again the instruction parameters
      pCard.parameters.children().trigger("vention_detach");
      pCard.parameters.children().detach();
      pCard.hideAxisButton();
      const lInstructionModel = pInstruction._getInstructionModel();
      const lAllAxesOption = (lInstructionModel.hasOwnProperty('uiProps') && lInstructionModel.uiProps.filteredByAllAxes);
      // build motor category and instruction applied to all axes (stopAllMotion, setSpeed, setAcceleration)
      // Add or not the + Axis buttons
      handleAddAxis();
      // This UI changes are to accommodate the + Axes button
      pCard.parameters.css({ 'max-width': '93%' });
      pCard.css({ 'flex-flow': 'row wrap' });

      const lCategory = pInstruction.getCategory();
      const lParametersHashed = hashByName(lInstructionModel.parameters);
      let axis = lParametersHashed.axis;
      const others = Object.keys(lParametersHashed).reduce(function (acc, curr) {
        if (curr !== 'axis') {
          acc[curr] = lParametersHashed[curr];
        }
        return acc;
      }, {});
        // In case the axis was removed, show a not selected option
      if (ml.reservedUuids.NONE == pInstruction.getParameter('axis')) { axis.values = [].concat(axis.values, null); }
      // Sequence to show Instruction: Axis, Actions, Other parameters;

      // if we don't have the axis property and we are adding a all axes options
      // create an fake axis parameter, so we for the axis field
      if (!axis && lAllAxesOption) { axis = lLibrary._getAllAxesParameters(); }

      axis && _parameterWidget(axis, 'axis');
      // Adding the instructions select ("Actions")
      pCard.parameters.append(pActions);
      // Adding any other parameters
      Object.keys(others).forEach(function (pInstructionKey) {
        _parameterWidget(others[pInstructionKey], pInstructionKey);
      });

      // Should be available only in the assembler
      if ( lLibrary.onTeachMode && "motor" == pInstruction.mCategory) {
        // Should be available for moveAbsolute and moveAbsoluteCombined
        if ( /moveAbsolute/.test(pInstruction.mName) )
        {
          const lIndex = pInstruction.getParameter("axis") - 1;

          const lFillColumns = $('<div></div><div></div>');
          pCard.parameters.append(lFillColumns);

          const lToolTipID = "teach_position_tooltip";
          let lToolTip = $('#' + lToolTipID);
          const ml_main = $('#ml_main');

          // Only need to have the css define once.
          // Only need one tooltip
          if ( 0 == lToolTip.length ) {
            // Note: All this is done here since we want to be independent from the vse code since one day
            // this will be moved to the assembler work space. Since it is code only used for the 3D machine logic.
            const  gIsEdge = ('undefined' != typeof navigator ? navigator.userAgent.match(/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i) : null);
            const _defineCssRule = function _defineCssRule(pName, pRule) {
              // Note: from http://stackoverflow.com/questions/1720320/how-to-dynamically-create-css-class-in-javascript-and-apply
              let lS = document.getElementById('teachMode_style');
              if(undefined == lS) {
                lS = document.createElement('style');
                lS.type = 'text/css';
                lS.id = 'teachMode_style';
                document.head.appendChild(lS);
              }
              if('string' == typeof pRule) {
                if (gIsEdge) {
                  if (pName.match(/webkit/) || pRule.match(/webkit/)) {
                    console.warn('Webkit vendor not supported [' + pName + ', ' + pRule + ']'); return;
                  }
                }
                lS.sheet.insertRule(pName + " {" + pRule + "}");
              } else {
                // just to give the ability to do _define('.test', { border: '1px red solid', border-radius: '1px' })
                pRule && lS.sheet.insertRule(pName + ' ' + JSON.stringify(pRule).replace(/\,/ig, ';').replace(/\"/ig, ''));
              }
            };

            // WARNING: z-index only work between sibling elements
            _defineCssRule('.teachMode_button',
              'position:relative; display:inline-block; background-color:#1C344F; color:#FFFFFF;'  +
                'padding:5px 10px; border:none;');
            _defineCssRule('.teachMode_button:active',
              'position:relative; display:inline-block; background-color:#1E2631; color:#FFFFFF;'  +
                'padding:5px 10px; border:none;');
            _defineCssRule('.teachMode_tooltip',
              'font-size: 14px; width: 240px; background-color: #FFFFFF; color: #1C344F;' +
                'box-shadow: 1px 2px 4px 2px grey;' +
                'border-radius: 6px; padding: 5px 25px; z-index: -1;' + // Set the z-index to low to be able to click on the main sequence element
                'position: absolute; transition: opacity 0.3s; overflow:visible;');
            //https://stackoverflow.com/questions/30299093/speech-bubble-with-arrow
            // This is to create a small rotated box that simulate an arrow for the tooltip
            _defineCssRule('.teachMode_tooltip:after',
              'content:""; z-index:9; position:absolute; top:50%; left:-3%; height:20px; width:20px;' +
                'transform:rotate(45deg); transform-origin:top right; background: #FFFFFF;');

            // Only need one tool tip for all button, since only one can be shown at a given time
            const lToolTipText =  "Click this button to teach the absolute position of the gantry from the home position (position 0).";
            lToolTip = $('<div id=' + lToolTipID + ' class="teachMode_tooltip">' + lToolTipText + '</div>');
            lToolTip.attr('visibility', 'hidden');
            lToolTip.css('opacity', '0');
            // The tool tip is at the ml_main level to be able to overflow
            ml_main.append(lToolTip);
          }

          const lOnClick = function OnClickTeachModeButton() {
            // Teach Mode available in the assembler only
            lLibrary.onTeachMode(pInstruction, lLibrary.getConfigManager());
          };

          const lTextButton = $('<button class="teachMode_button">Teach Position</button>');
          lTextButton.on('click', lOnClick);

          // The tooltip will appear only when hovering for more than 0.75sec over the 'Teach Position' button.
          // so the visibility change is delayed by 0.75sec
          const hoverIn = function hoverInTeachMode() {
            const mainOffset = ml_main.offset();
            const buttonBounds = this.getBoundingClientRect();
            const x = buttonBounds.left - mainOffset.left + buttonBounds.width + 20; // Not sure why the +20 but probably the padding
            const y = buttonBounds.top - mainOffset.top + buttonBounds.height / 2 + lToolTip.height() / 2;

            window.myTimeOut = setTimeout(function() {
              const lItem = $('#' + lToolTipID);
              lItem.attr('visibility', 'visible');
              lItem.css('opacity', '1');
              lItem.css({left: x + 'px'});
              lItem.css({top: y + 'px'});
              lItem.css({'z-index': '9'});
            }, 750);
          };
          const hoverOut = function hoverOutTeachMode(){
            const lItem = $('#' + lToolTipID);
            lItem.attr('visibility', 'hidden');
            lItem.css('opacity', '0');
            clearTimeout(window.myTimeOut);
          };

          lTextButton.hover(hoverIn, hoverOut);

          const lTeachPositionID = "axis" + lIndex + "_teach_position";
          const lTeachPosition = $('<div id=' + lTeachPositionID + ' style="float:right;"</div>').append(lTextButton);
          pCard.parameters.append(lTeachPosition);

          const lHandlerIn = function onTeachModeHandlerIn() {
            lLibrary.addTeachModeMeasurements(pInstruction);
          };
          pCard.bind("mouseenter", lHandlerIn);

          const lHandlerOut = function onTeachModeHandlerOut() {
            lLibrary.removeTeachModeMeasurements(pInstruction);
          };
          pCard.bind("mouseleave", lHandlerOut);
        }
        else {
          lLibrary.removeTeachModeMeasurements(pInstruction);
          pCard.unbind('mouseenter mouseleave');
        }
      }

      // Update Icon category and label
      // When we have all axes option
      // we can show the right category and icons
      pCard.updateIcon(icons[lCategory]);
      pActions.updateLabel(utils.replaceCategory(lCategory));

      // Show add Axis button and
      // show tooltip help icon beside Axis/Actuator label
      if ('motor' === pInstruction.getCategory() && pInstruction.getName().match(/(relative|absolute)/i)) {
        // For ONE-DRIVE, we will hide the plus button when switching from combined to single to prevent the combined instruction
        const lAxis = lLibrary.getConfigManager().getAxisByUuid(_lCachedAxisUuid);
        const lConfig = lAxis ? lAxis.getConfig() : undefined;

        if((lConfig && lConfig.maxNumberOfAxes() > 1) || pInstruction.getName().match(/combined/i)) {
          pCard.showAxisButton();
        }
        const lActuatorWidgets = pCard.find(
          '.ml_parameters > .ml_parameter > .h_layout'
        );
        let _lExistingIcon;
        if (lActuatorWidgets.length) {
          if ('motor' === pInstruction.getCategory() && !lAllAxesOption) {
            const lIcon = $(
              '<div class="ml_label_icon ' +
                  icons.unknown +
                  ' ml_tooltip_icon"/>'
            ).click(function () {
              tooltips.showTips('addActuators');
            });
            _lExistingIcon = $(lActuatorWidgets[0]).find('.ml_label_icon');
            if (_lExistingIcon.length) {
              _lExistingIcon.replaceWith(lIcon);
            } else {
              $(lActuatorWidgets[0]).append(lIcon);
            }
          } else {
            _lExistingIcon = $(lActuatorWidgets[0]).find('.ml_label_icon');
            if (_lExistingIcon.length) {
              _lExistingIcon.detach();
            }
          }
        }
      }
      // Show tooltip icon beside instruction label
      const tooltipInstructionMatch = lInstruction
        .getName()
        .match(/combined/i) != null
        ? lInstruction.getName().replace(/combined/i, '')
        : lInstruction.getName();
      if (tooltips.keys[tooltipInstructionMatch]) {
        pActions.setLabelIcon(
          $('<div class="ml_tooltip_icon ' + icons.unknown + '"/>').click(
            function () {
              tooltips.showTips(tooltipInstructionMatch);
            }
          )
        );
      } else {
        pActions.detachLabelIcon();
      }
    };
      /**
       * Build the right layout instruction
       * for combined movements
       */
    const buildCombinedInstruction = function (pCard, pParameterInfo) {
      pCard.parameters.children().detach();
      // Note (alevy): we are looping through the axis count

      // NOTE: unfortunetely we cant build a variable actuator list as the axes are sanitized at Instruction.fromJson level
      // NOTE: where invalid drives are set to zero, thus not possible to descriminate from unused ones

      for (let i = 0; i < pParameterInfo.count; ++i) {
        const lParametersHashed = hashByName(pParameterInfo.unit);
        const lAxis = lParametersHashed.axis;
        const lOthers = Object.keys(lParametersHashed).reduce(function (pAccumulator, pCurrent) {
          if ('axis' !== pCurrent) {
            pAccumulator[pCurrent] = lParametersHashed[pCurrent];
          }
          return pAccumulator;
        }, {});
          // Create the Actuator widget for each axis.
        pCard.parameters.append(_parameterWidget(lAxis, pParameterInfo.name + '.' + i + '.' + lAxis.name));
        // Create the Motion widget (only for the 1st axis; a placeholder is inserted for other axes).
        if (0 === i) {
          // Show the motion only on the first line
          _lCachedAxisUuid = _lGetFirstValidAxisUuid();
          pCard.parameters.append(_lActions);
        } else {
          // adding the blank only in the UI side, it does not change anything on the instruction parameters.
          pCard.parameters.append(_parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, 'blank'));
        }
        // Create the distance widget for each axis.
        Object.keys(lOthers).forEach(function (pInstructionKey) {
          pCard.parameters.append(_parameterWidget(lOthers[pInstructionKey], pParameterInfo.name + '.' + i + '.' + pInstructionKey));
        });
      }
    };
      /**
       * Takes care of adding or not the "+ Axis" button in the card
       */
    const handleAddAxis = function () {
      if (!_lCard.hasAddAxis()) {
        _lCard.addAxisButton(_lAddAxisButton);
        if (lInstruction.getName().match(/combined/i)) {
          _lAddAxisButton.updateIcon(icons.removeCircle);
          // toggle the switch combine
          _lSwitchedToCombinedMovement = true;
        }
      }
    };

    _lCachedAxisUuid = lInstruction.getParameter('axis');
    _lCard.icon.find('h5').addClass('ml_number');
    _lCard.icon.removeClass('ml_icon').addClass('ml_icon_instruction_widget');

    function isInstructionOutsideOfActionList(_pList, _pInstructionName) {
      // data example : [{ value: "moveRelative", text: "moveRelative"}, {{ value: "moveAbsolute", text: "moveAbsolute"}}]
      const _lFlatValueList = _pList.map(function (obj) { return obj && obj.value; });
      return !_lFlatValueList.includes(_pInstructionName);
    }

    const _lActionSet = lLibrary.getInstructionSet()[lInstruction.getCategory()];
    if (_lActionSet) {
      // Please see VentionCo/mm-vention-control#569
      const lReplaceCategory = utils.replaceCategory(lInstruction.getCategory());
      const lInstructionName = lInstruction.getName();
      _lFilteredActionsSet = getActions(lLibrary, lInstruction, _lCachedAxisUuid);
      const lActionsList = utils.getActionList(_lFilteredActionsSet);

      if (isInstructionOutsideOfActionList(lActionsList, lInstructionName)){
        // If the current instruction is not compatible with the config, display it as a deprecated one (greyed out)
        const lInstructionModel = lInstruction._getInstructionModel();
        const lText = lInstructionModel.hasOwnProperty('uiProps') ? lInstructionModel.uiProps.displayName : lInstructionName;
        lActionsList.push({ value: lInstructionName, text: widgets.camelCaseToText(lText), deprecated: true });
      }
      _lActions = widgets.listWidget(lReplaceCategory, lActionsList, 'Action to be performed', lInstructionName, _onAction);

      if(lLibrary.getConfigManager().numberOfAxes() == 0) { _lActions.getSelect().attr('disabled', 'disabled'); }

      buildInstruction(_lCard, lInstruction, _lActions);
      _lCard.append($('<div class="ml_animated_background"/>'));
      _lDiv.append(_lCard);
      lInstruction.addListener(_lInstructionListener);
    }

    _lDiv.on('remove', function onRemoveMotorInstruction() {
      lInstruction.removeListener(_lInstructionListener);
    });

    return _lDiv;
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    create: create,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());
